// 引入 React 运行时。
import React from 'react';
// 引入国际化 Hook。
import { useTranslations } from 'next-intl';
// 引入通用弹窗组件。
import CommonModal from '@/components/UploadCommonModal';
// 引入通用图片组件。
import CommonImage, { ImageType } from '@/components/CommonImage';
// 引入通用图标组件。
import CommonIcon from '@/components/CommonIcon';
// 引入设备类型。
import { IUserEquipment } from '@/api/device';
// 引入样式。
import Styles from './index.module.scss';

// 我的设备弹窗入参类型。
interface IMyDevicesModalProps {
  visible: boolean;
  onClose: () => void;
  devices: IUserEquipment[];
  isSelfView?: boolean;
  onDeviceClick?: (deviceLink?: string, productName?: string) => void;
}

// 我的设备弹窗组件。
const MyDevicesModal = ({ visible, onClose, devices, isSelfView = true, onDeviceClick }: IMyDevicesModalProps) => {
  // 国际化函数。
  const t = useTranslations();
  // 不可见时不渲染。
  if (!visible) return null;

  return (
    <CommonModal
      title={
        <div className={Styles.modalHeader}>
          <div className={Styles.titleText}>{isSelfView ? t('user_center_pc_my_devices') : t('user_center_pc_ta_devices')}</div>
          <div className={Styles.subtitleText}>{t('user_profile_devices_count', { count: devices.length })}</div>
        </div>
      }
      onCancel={onClose}
      contentClassName={Styles.root}
      headerClassName={Styles.modalHeaderWrapper}
      closeIcon={<CommonIcon icon="my-sb-modal-close" className={Styles.closeIcon} />}
    >
      <div className={Styles.deviceGrid}>
        {devices.map((device, index) => (
          <div
            key={device.key || index}
            className={Styles.deviceItem}
            onClick={() => {
              // 优先走外部点击回调。
              if (onDeviceClick) {
                onDeviceClick(device.home_page, device.name);
                return;
              }
              // 无回调时直接打开设备链接。
              if (device.home_page) {
                window.open(device.home_page, '_blank');
              }
            }}
          >
            <div className={Styles.imageWrapper}>
              <CommonImage
                src={device.icon || ''}
                type={ImageType.device}
                width={64}
                height={64}
                alt={device.name}
                className={Styles.deviceImage}
              />
            </div>
            <span className={Styles.deviceName} title={device.name}>
              {device.name}
            </span>
          </div>
        ))}
      </div>
    </CommonModal>
  );
};

// 导出组件。
export default MyDevicesModal;
